import React, { useState, useEffect } from 'react';
import "../CSS/Marker.css"

import {
    Marker
  } from "react-simple-maps";

function MapMarker(props) {
    useEffect(() =>  {
        console.log("zoom", props.zoom)
    })

    function getFontSizeByZoom(zoom) {
        const zoomProps = {0:5, 1:4, 2:4, 3: 3, 4:2.5, 5:2, 6:2, 7:2, 8:1.5, 
            9:1.5, 10:1.5, 11:1.5, 12:1.5, 13:1.5, 14:1.5, 15:1.3};
        return zoomProps[Math.round(zoom)]
    }

	return (
        <Marker coordinates={props.coordinates} fill="#777" sx={{cursor: 'pointer'}}>        
            <circle id={props.name} r={1.5}
            class={props.regionChosen === props.name ? "highlightmarker" : "marker"}
            onClick={(event) => props.handleClick(event.currentTarget, props.name)}
            onMouseEnter ={() => 0} 
            onMouseLeave ={() => 0} 
            />
            <text fill="black"
            class={props.regionChosen === props.name ? "markerTextHighlight" : ""}
            // font-size={props.teaType === props.name ? 20 / props.zoom : 16 / props.zoom}
            font-size={props.regionChosen === props.name ? 
                getFontSizeByZoom(props.zoom) : getFontSizeByZoom(props.zoom)}
             textAnchor='middle' y="3" >{props.name}</text> 
      </Marker>
	)
}

export default MapMarker;